var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow-y":"scroll"},attrs:{"id":"app"}},[_c('div',{staticClass:"container",staticStyle:{"clear":"both","height":"100vh"},attrs:{"id":"container"}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }